import Page from "../../common/Page.js";
import about1 from "../../assets/about_img/about1.jpg";
import about2 from "../../assets/about_img/about2.jpg";
import about3 from "../../assets/about_img/about3.jpg";

class AboutPage extends Page {
  constructor() {
    super({
      id: "about",
      title: "О проекте",
      content: `
        <div class="about-page">
          <h2 class="about-section-title">Цель создания и методическая основа</h2>
          
          <p>
            Веб-приложение Кондитер-Pro создано на основании сборника заданий и тестовых 
            материалов контроля и оценки результатов деятельности, 
            обучающихся по учебному предмету "Специальная технология" для специальности "Обслуживание и изготовление продукции в общественном 
            питании", квалификация "Кондитер 4 разряда". Сборник разработан преподавателем Ляховской Анной Егоровной. 
          </p>
          <p>Цель создания: Автоматизация и повышение эффективности процессов обучения, 
          контроля и оценки знаний обучающихся по специальности «Кондитер 4 разряда» на основе 
          современных цифровых технологий.</p>
          <p>
            Веб-приложение 
             включает все основные темы программы и предлагает различные формы тестирования, 
             включая вопросы с выбором ответа, задания 
             на дополнение и установление соответствия. Оно разработано для поддержки процесса обучения,
              контроля и интерактивной оценки
             знаний обучающихся.
          </p>
          <p>
            Помимо заданий для тестирования, в приложении представлены разделы с контрольными вопросами и темами
             проектов, что помогает направить внимание обучающихся на более глубокое изучение материала и подготовиться к практическим занятиям и экзаменам.
           
          </p>
          <p>
            Для визуального сопровождения учебного материала в приложении размещено более 250 картинок, которые наглядно иллюстрируют основные 
            темы и помогают обучающимся лучше понимать и запоминать изучаемые процессы.
          </p>
          <p>
            Платформа предоставляет удобные инструменты для преподавателей и обучающихся: автоматический 
            расчет результатов, визуализацию прогресса,
             а также мгновенную обратную связь по итогам тестирования. Обучающиеся могут закреплять знания, 
             проходя тесты по темам, а преподаватель имеет
              возможность объективно оценивать успеваемость и анализировать результаты в динамике.
          </p>
          <p>
            Для обеспечения удобства и прозрачности оценки предусмотрены две шкалы, которые переводят баллы в итоговую отметку, что способствует 
            стандартизации системы оценивания и повышает эффективность контроля знаний. Для максимального 
            удобства пользователей реализована полнофункциональная мобильная версия, обеспечивающая доступ ко всем
             возможностям приложения с любых устройств.
          </p>
          
          <h2 class="about-section-title">Личный кабинет обучающегося</h2>
          <p>
            Каждый обучающийся имеет доступ к персональному кабинету, который предоставляет широкие возможности 
            для управления учебным процессом. 
            В личном кабинете обучающийся может указать и редактировать свои данные: фамилию, имя и номер группы.
             Это позволяет преподавателю 
            легко идентифицировать обучающихся и организовывать их по группам для удобного мониторинга успеваемости.
          </p>
          <p>
            В кабинете обучающегося отображается полная история прохождения тестов с указанием даты прохождения и полученной оценки. 
            Это позволяет отслеживать прогресс и видеть динамику улучшения результатов. 
          </p>
          <p>
            Дополнительно в личном кабинете реализована система управления файлами. Обучающиеся могут загружать свои работы, проекты, конспекты 
            и другие учебные материалы. Поддерживаются различные форматы файлов: изображения, PDF-документы, документы Word, Excel, PowerPoint 
            и текстовые файлы. Загруженные файлы можно просматривать, скачивать и удалять, что обеспечивает удобное хранение и организацию 
            учебных материалов в одном месте.
          </p>

          <h2 class="about-section-title">Кабинет преподавателя</h2>
          <p>
            Преподаватели имеют доступ к специальному административному кабинету, который предоставляет комплексные инструменты для мониторинга 
            и управления учебным процессом. В кабинете преподавателя все обучающиеся автоматически организованы по группам, что значительно упрощает 
            навигацию и поиск нужных обучающихся. Также отображается отдельный раздел для пользователей, которые еще не указали номер группы.
          </p>
          <p>
            Для каждого обучающегося преподаватель может просмотреть детальную информацию о всех пройденных тестах. Это включает название теста, 
            дату и время прохождения, детализацию ответов на каждый вопрос с указанием правильности, набранные баллы и итоговую оценку. 
            Такая подробная информация позволяет преподавателю объективно оценивать знания обучающихся и выявлять области, требующие дополнительного 
            внимания.
          </p>
          <p>
            В кабинете преподавателя также реализован полный доступ к файлам, загруженным обучающимися. Преподаватель может просматривать список 
            всех файлов каждого обучающегося, скачивать их для проверки и при необходимости удалять. Это обеспечивает удобный контроль за выполнением 
            заданий и проектов, а также позволяет организовать эффективную обратную связь с обучающимися.
          </p>
          <p>
            Дополнительно в кабинете преподавателя предусмотрена возможность управления пользователями: удаление аккаунтов обучающихся при необходимости, 
            что обеспечивает гибкость в администрировании системы и поддержании актуальности списка пользователей.
          </p>
          
          <div class="about-images">
            <img src="${about1}" alt="Брауни">
            <img src="${about2}" alt="Десерт из взбитых сливок">
            <img src="${about3}" alt="Варенье">
          </div>
        </div>
      `,
      metaTitle: "О проекте",
    });
  }

  renderPage() {
    return this.render(); // Используем метод render из родительского класса
  }
}

export default AboutPage;

